<template>
  <div class="gang-sheet-builder-pdp-tile">
    <div
      :class="{
        'gang-sheet-builder-pdp-tile__button': true,
        'gang-sheet-builder-pdp-tile__button--selected': isSelected
      }"
      @click="handleClick(value.value)"
    >
      {{ value.label }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Tile",
  props: {
    value: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(value) {
      this.$emit("tile-selected", value);
    }
  }
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/settings.scss";

.gang-sheet-builder-pdp-tile {
  &__button {
    display: flex;
    flex-direction: column;
    gap: 5px;
    border-radius: 8px;
    border: 1px solid $gray-label;
    padding: 8px 16px;
    text-align: center;
    cursor: pointer;
    font-weight: 700;

    &--selected {
      border-radius: 8px;
      border: 2px solid $primary-600;
    }
  }
}
</style>
